import { defineMessages } from 'react-intl';

export const estimationApproveButtonMessageDefinitions = defineMessages({
  cancelReviewButton: {
    id: 'estimationDetail.approveButton',
    defaultMessage: 'Approve',
  },
});
